"use strict";Object.defineProperty(exports, "__esModule", {value: true});// src/markdown-it-plugins/parseAttrName.ts
var open = 123;
var close = 125;
var parseAttrName = (state, start, disableNested) => {
  let level = 1;
  const max = state.posMax;
  for (let pos = start + 1; pos < max; pos++) {
    const marker = state.src.charCodeAt(pos);
    if (marker === close) {
      level--;
      if (level === 0) {
        return pos;
      }
    } else if (marker === open) {
      if (disableNested) {
        return -1;
      }
      level++;
    }
    if (marker === 92 && pos + 1 < max) {
      pos++;
    }
  }
  return -1;
};

// src/markdown-it-plugins/parseContent.ts
var open2 = 40;
var close2 = 41;
var parseContent = (state, start) => {
  const max = state.posMax;
  let pos = start;
  if (pos >= max || state.src.charCodeAt(pos) !== open2) {
    return -1;
  }
  pos++;
  let level = 1;
  while (pos < max) {
    const char = state.src.charCodeAt(pos);
    if (char === close2) {
      level--;
      if (level === 0) {
        return pos;
      }
    } else if (char === open2) {
      level++;
    }
    pos++;
  }
  return -1;
};

// src/markdown-it-plugins/color.ts
var color = (md) => {
  const tokenize = (state, silent) => {
    const max = state.posMax;
    if (state.src.charCodeAt(state.pos) !== 123) {
      return false;
    }
    const labelStart = state.pos + 1;
    const labelEnd = parseAttrName(state, state.pos, true);
    if (labelEnd < 0) {
      return false;
    }
    const fullColorName = state.src.substring(labelStart, labelEnd);
    const isBackground = fullColorName.startsWith("bg-");
    const colorName = isBackground ? fullColorName.replace(/^bg-/, "") : fullColorName;
    const contentStart = labelEnd + 2;
    const contentEnd = parseContent(state, labelEnd + 1);
    if (contentEnd < 0) {
      return false;
    }
    if (!silent) {
      state.pos = contentStart;
      state.posMax = contentEnd;
      const openToken = state.push("color_open", "span", 1);
      openToken.attrs = [];
      openToken.attrs.push([
        "style",
        `${isBackground ? "background-color" : "color"}:${colorName}`
      ]);
      openToken.info = colorName;
      const content = state.src.slice(contentStart, contentEnd);
      const childState = new state.md.inline.State(content, state.md, state.env, []);
      childState.md.inline.tokenize(childState);
      for (let i = 0; i < childState.md.inline.ruler2.getRules("").length; i++) {
        const rules = childState.md.inline.ruler2.getRules("");
        rules[i](childState);
      }
      state.tokens.push(...childState.tokens);
      const closeToken = state.push("color_close", "span", -1);
      closeToken.info = colorName;
    }
    state.pos = contentEnd + 1;
    state.posMax = max;
    return true;
  };
  md.inline.ruler.before("emphasis", "color", tokenize);
};

// src/markdown-it-plugins/underline.ts
var underline = (md) => {
  const tokenize = (state, silent) => {
    const max = state.posMax;
    if (state.src.charCodeAt(state.pos) !== 123) {
      return false;
    }
    const labelStart = state.pos + 1;
    const labelEnd = parseAttrName(state, state.pos, true);
    if (labelEnd < 0 || state.src.substring(labelStart, labelEnd) !== "underline") {
      return false;
    }
    const contentStart = labelEnd + 2;
    const contentEnd = parseContent(state, labelEnd + 1);
    if (contentEnd < 0) {
      return false;
    }
    if (!silent) {
      state.pos = contentStart;
      state.posMax = contentEnd;
      const openToken = state.push("u_open", "u", 1);
      openToken.info = "underline";
      const content = state.src.slice(contentStart, contentEnd);
      const childState = new state.md.inline.State(content, state.md, state.env, []);
      childState.md.inline.tokenize(childState);
      for (let i = 0; i < childState.md.inline.ruler2.getRules("").length; i++) {
        const rules = childState.md.inline.ruler2.getRules("");
        rules[i](childState);
      }
      state.tokens.push(...childState.tokens);
      const closeToken = state.push("u_close", "u", -1);
      closeToken.info = "underline";
    }
    state.pos = contentEnd + 1;
    state.posMax = max;
    return true;
  };
  md.inline.ruler.before("emphasis", "underline", tokenize);
};




exports.color = color; exports.underline = underline;
//# sourceMappingURL=chunk-S6POSSI2.js.map